import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import Logo from "./Logo";
import "./Layout.css";

function Layout() {
  const [navOpen, setNavOpen] = useState(false);
  const closeNav = () => setNavOpen(false);

  return (
    <div className="site-wrapper">
      <header className="site-header">
        <Link to="/" className="header-logo" aria-label="CountyLee Home" onClick={closeNav}>
          <Logo />
        </Link>
        <nav className={`main-nav ${navOpen ? "is-open" : ""}`} aria-label="Main navigation">
          <Link to="/" onClick={closeNav}>Home</Link>
          <Link to="/calculator" onClick={closeNav}>Calculator</Link>
          <Link to="/about" onClick={closeNav}>About</Link>
          <Link to="/faq" onClick={closeNav}>FAQ</Link>
          <Link to="/contact" onClick={closeNav}>Contact</Link>
        </nav>
        <button
          className="nav-toggle"
          aria-label="Toggle menu"
          type="button"
          onClick={() => setNavOpen(!navOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </header>
      <main className="site-main">
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="footer-inner">
          <p>&copy; {new Date().getFullYear()} Leaton Mitchell. All rights reserved.</p>
          <p>
            <Link to="/privacy">Privacy &amp; Legal</Link>
            {" · "}
            <a href="https://leaton.dev" target="_blank" rel="noopener noreferrer">leaton.dev</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
